// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponsePropagation } from './ResponsePropagation';
import {
  ResponsePropagationFromJSON,
  ResponsePropagationFromJSONTyped,
  ResponsePropagationToJSON,
  ResponsePropagationToJSONTyped,
} from './ResponsePropagation';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';
import type { ResponseClusterCurrentStep } from './ResponseClusterCurrentStep';
import {
  ResponseClusterCurrentStepFromJSON,
  ResponseClusterCurrentStepFromJSONTyped,
  ResponseClusterCurrentStepToJSON,
  ResponseClusterCurrentStepToJSONTyped,
} from './ResponseClusterCurrentStep';
import type { ResponseCondition } from './ResponseCondition';
import {
  ResponseConditionFromJSON,
  ResponseConditionFromJSONTyped,
  ResponseConditionToJSON,
  ResponseConditionToJSONTyped,
} from './ResponseCondition';

/**
 *
 * @export
 * @interface ResponseClusterRolloutSummary
 */
export interface ResponseClusterRolloutSummary {
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutSummary
   */
  clusterName?: string;
  /**
   *
   * @type {Array<ResponseCondition>}
   * @memberof ResponseClusterRolloutSummary
   */
  conditions?: Array<ResponseCondition>;
  /**
   *
   * @type {ResponseClusterCurrentStep}
   * @memberof ResponseClusterRolloutSummary
   */
  currentStep?: ResponseClusterCurrentStep;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutSummary
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseClusterRolloutSummary
   */
  operatorName?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof ResponseClusterRolloutSummary
   */
  pendingActionIds?: Array<number>;
  /**
   * Propagation is omitted when no action has been propagated to the
   * cluster yet, i.e. it has no propagation state.
   * @type {ResponsePropagation}
   * @memberof ResponseClusterRolloutSummary
   */
  propagation?: ResponsePropagation;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseClusterRolloutSummary
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
}

/**
 * Check if a given object implements the ResponseClusterRolloutSummary interface.
 */
export function instanceOfResponseClusterRolloutSummary(
  value: object,
): value is ResponseClusterRolloutSummary {
  return true;
}

export function ResponseClusterRolloutSummaryFromJSON(
  json: any,
): ResponseClusterRolloutSummary {
  return ResponseClusterRolloutSummaryFromJSONTyped(json, false);
}

export function ResponseClusterRolloutSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseClusterRolloutSummary {
  if (json == null) {
    return json;
  }
  return {
    clusterName: json['clusterName'] == null ? undefined : json['clusterName'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ResponseConditionFromJSON),
    currentStep:
      json['currentStep'] == null
        ? undefined
        : ResponseClusterCurrentStepFromJSON(json['currentStep']),
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    operatorName:
      json['operatorName'] == null ? undefined : json['operatorName'],
    pendingActionIds:
      json['pendingActionIds'] == null ? undefined : json['pendingActionIds'],
    propagation:
      json['propagation'] == null
        ? undefined
        : ResponsePropagationFromJSON(json['propagation']),
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
  };
}

export function ResponseClusterRolloutSummaryToJSON(
  json: any,
): ResponseClusterRolloutSummary {
  return ResponseClusterRolloutSummaryToJSONTyped(json, false);
}

export function ResponseClusterRolloutSummaryToJSONTyped(
  value?: ResponseClusterRolloutSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusterName: value['clusterName'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ResponseConditionToJSON),
    currentStep: ResponseClusterCurrentStepToJSON(value['currentStep']),
    identifier: value['identifier'],
    operatorName: value['operatorName'],
    pendingActionIds: value['pendingActionIds'],
    propagation: ResponsePropagationToJSON(value['propagation']),
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
  };
}
